export default "__VITE_ASSET__C4dXAzzE__"